<template>
  <el-container class="branch-performance-months pagination-list">
    <el-main>
      <div class="content">
        <el-col :span="22" class="branch-performance-months-search">
          <el-form>
            <el-form-item label="起始时间:" label-width="80px">
              <el-date-picker v-model="searchParams.startTime" value-format="yyyy-MM-dd" type="month"></el-date-picker>
            </el-form-item>

            <el-form-item label="终止时间:" label-width="80px">
              <el-date-picker v-model="searchParams.endTime" value-format="yyyy-MM-dd" type="month"></el-date-picker>
            </el-form-item>

            <el-form-item label="所属分公司" label-width="80px">
              <el-input :title="filiale" v-model="filiale" placeholder="总公司" readonly @click.native.prevent="openDialog"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="search" size="mini">生成</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <div class="echarts-bar-line" ref="echartsBarLine"></div>
        <select-filiale-dialog
          :dialogVisible="dialogVisible"
          :default-checked-keys="['0005A41F-0000-0000-0000-0000FDA5314A']"
          @setFiliale="setFiliale"
          @setSelectList="setSelectList"
          @closeDialog="closeDialog"></select-filiale-dialog>
        <div class="rank-text" v-show="rankData.length !== 0">
          <p v-for="(rank,index) in rankData" :key="index">
            <span v-if="rank.data.length > 0">
              {{rank.month}}份考核销售额排名前五的分公司分别为:
              <span v-for="data in rank.data" :key="data.companyId">
                {{data.companyName}}（{{data.totalMoney / 10000}}万元）、
              </span>
              {{filiale}}{{rank.selectCompanyRank?'排名'+rank.selectCompanyRank:'无出单'}}
            </span>
            <span v-else>{{rank.month}}份暂无销售额</span>
          </p>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import SelectFilialeDialog from './publicDialog/select-filiale-dialog.vue'
import Vue from 'vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/line')
require('echarts/lib/component/tooltip')
Vue.use(echarts)
export default {
  name: 'branch-performance-months',
  components: {SelectFilialeDialog},
  data () {
    return {
      dialogVisible: false,
      // 已选分公司
      selectList: [],
      searchParams: {
        startTime: moment().subtract(30, 'days').format('YYYY-MM-01'),
        endTime: moment().format('YYYY-MM-01')
      },
      filiale: '',
      // 排名数据
      rankData: []
    }
  },
  mounted () {
    this.drawEcharts()
    // 监听窗口大小变化重绘echarts
    window.onresize = _.debounce(() => {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.resize()
    }, 100)
  },
  methods: {
    drawEcharts () {
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.setOption({
        title: {
          text: '分公司月度业绩分析',
          textStyle: {
            color: '#2A2929',
            fontSize: 20
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            snap: 'true'
          }
        },
        grid: {
          bottom: 80
        },
        legend: {
          bottom: 30,
          itemGap: 100,
          formatter: (name) => {
            if (name.indexOf('额') !== -1) {
              return name + '/万'
            } else {
              return name + '/件'
            }
          },
          data: [
            {
              name: '销售额'
            },
            {
              name: '销售件数'
            }]
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            formatter: (value) => {
              return moment(value).format('YYYY年MM月')
            }
          }
        },
        yAxis: [{
          minInterval: 1,
          axisLabel: {
            formatter: '{value}件'
          }
        }, {
          axisLabel: {
            formatter: '{value}万'
          }
        }],
        series: [
          {
            name: '销售件数',
            type: 'line',
            yAxisIndex: 0,
            itemStyle: {
              color: '#ED7D31'
            }
          },
          {
            name: '销售额',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: '#5B9BD5'
            }
          }
        ]
      })
    },
    openDialog () {
      this.dialogVisible = true
    },
    // 当前选中分公司
    setFiliale (filiale) {
      this.filiale = filiale
    },
    setSelectList (selectList) {
      this.selectList = selectList
      this.dialogVisible = false
    },
    closeDialog () {
      this.dialogVisible = false
    },
    search () {
      if (!this.searchParams.startTime) {
        return this.$message.error('请选择起始时间')
      }
      if (!this.searchParams.endTime) {
        return this.$message.error('请选择终止时间')
      }
      if (new Date(this.searchParams.startTime).getTime() > new Date(this.searchParams.endTime).getTime()) {
        return this.$message.error('起始时间不能大于终止时间')
      }
      this.rankData = []
      let ids = this.selectList.map(e => e.id)
      let data = {
        startDate: this.searchParams.startTime,
        endDate: this.searchParams.endTime,
        ids: ids
      }
      let myCharts = echarts.init(this.$refs.echartsBarLine)
      myCharts.showLoading({
        text: '加载中...',
        color: '#47A2FF',
        textColor: '#47A2FF',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0
      })
      this.$axios.post('/huaao-api/visualReport/getMonthAnalyse', data).then(res => {
        let echartsData = res.data.data
        // 排名文本展示
        let rankData = res.data.rank
        if (rankData) {
          Object.keys(rankData).forEach(item => {
            this.rankData.push({month: moment(item).format('YYYY年MM月'), data: rankData[item].rank, selectCompanyRank: rankData[item].num})
          })
        }
        let xAxisData = []
        let barYAxis = []
        let lineYAxis = []
        Object.keys(echartsData).forEach(monthData => {
          let currentMonthCount = 0
          let currentMonthMoney = 0
          xAxisData.push(monthData)
          // 合并当前月份选择的公司的销售件数和销售额
          echartsData[monthData].forEach(item => {
            currentMonthCount += item.count
            currentMonthMoney += item.totalMoney / 10000
          })
          barYAxis.push(currentMonthMoney)
          lineYAxis.push(currentMonthCount)
        })
        myCharts.setOption({
          xAxis: {
            data: xAxisData
          },
          series: [
            {
              data: lineYAxis
            },
            {
              data: barYAxis
            }
          ]
        })
        myCharts.hideLoading()
      }).catch(() => {
        myCharts.hideLoading()
      })
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .el-container.branch-performance-months {
    .content {
      height: calc(100% - 80px);

      .branch-performance-months-search {
        .el-form {
          display: flex;
          flex-wrap: nowrap;
          overflow-x: scroll;
          height: 46px;
          .el-form-item{
            flex: 0 1 auto;
          }
          .el-form-item:nth-of-type(4){
            margin-left: 10px;
          }
          .el-form-item:last-of-type{
            margin-left: 50px;
          }
        }
        .el-button{
          padding: 4px 10px;
          border-color: #55ACF1;
          color: #55ACF1;
          span{
            font-size: 12px;
          }
        }
      }
      .echarts-bar-line{
        width: 92%;
        height: 92%;
        min-width: 800px;
        min-height: 600px;
        margin: 50px auto 0;
      }
      .select-filiale{
        .dialog-content {
          height: 500px;
          overflow: auto;
        }
      }
      .rank-text{
        text-align: left;
        padding-left: 80px;
        p{
          line-height: 22px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/page/huaao/visualReport/branch-performance-months.vue